import PropTypes from "prop-types";
import ProcessRow from "../ProcessRow";

export default function ProcessRowToimitusvalmis(props) {
  const thisProcess = props.thisProcess;
  const isConfirmed = props.thisProcess.tilausHyväksytty.isConfirmed;
  const confirmDate = props.thisProcess.tilausHyväksytty.confirmDate;

  const handleKlik = async () => {
    if (thisProcess.tilausHyväksytty.isConfirmed) {
      await thisProcess.tilausHylkää();
    } else {
      await thisProcess.tilausHyväksy();
      props.setThisProcess(thisProcess);
    }
  };

  function getTip() {
    return "Vahvista tilaus heti ja merkitse se toimitusvalmiiksi";
  }

  return (
    <ProcessRow
      txt="Tilaus on toimitusvalmis"
      tip={getTip()}
      done={isConfirmed}
      pvm={confirmDate}
      onClick={() => handleKlik()}
      aria-label="Tilauksen hyväksyntä"
      disableTextClick
    />
  );
}

ProcessRowToimitusvalmis.propTypes = {
  thisProcess: PropTypes.object,
  setThisProcess: PropTypes.func,
};
